import { StyledIconButton } from "@components/button";
import { darken, ellipsis } from "polished";
import styled, { DefaultTheme } from "styled-components";

interface ITokenProps {
    selected: boolean;
    $color: string;
    $isLabel: boolean;
}

const getColor = (props: ITokenProps & { theme: DefaultTheme }, isSelected?: boolean): string => {
    if (!props.$color) {
        return "transparent";
    }
    const color = props.theme[props.$color as keyof DefaultTheme] || props.$color;
    if (isSelected) {
        return darken(0.1, color);
    }
    return color;
};

const getBorderColor = (props: ITokenProps & { theme: DefaultTheme }): string => {
    if (!props.$color) {
        // hide border if tokens don't have background color, otherwise it looks weird
        // used for fake tokens in multiselect when we want to show "x more" without background color
        return "transparent";
    }
    if (props.$isLabel) {
        return getColor(props, props.selected);
    }
    return props.selected ? props.theme.C_ACT_main : props.theme.C_FIELD_line;
};

export const StyledToken = styled.div<{
    selected: boolean;
    $color: string;
    $isLabel: boolean;
    $isSelectable: boolean;
    $isRound: boolean;
    $hasIcon: boolean;
}>`
    padding: ${props => props.$color ? "2px 5px" : 0};
    height: 22px;
    border-radius: ${props => props.$isRound ? "11px" : props.theme.borderRadius};
    border: solid 1px ${props => getBorderColor(props)};
    background-color: ${props => props.selected ? props.theme.C_FIELD_line : "transparent"};
    color: ${props => props.theme.C_TEXT_primary};

    ${props => props.$color && `
        background-color: ${getColor(props, props.selected)}
    `};
    width: fit-content;
    flex: 0 0 auto;
    user-select: none;
    ${ellipsis()};

    font-weight: ${props => props.$isLabel ? "bold" : "normal"};
    text-transform: ${props => props.$isLabel ? "uppercase" : null};
    font-size: ${props => props.$isLabel ? "12px" : "14px"};

    &:hover {
        border-color: ${props => props.$isSelectable ? props.theme.C_ACT_main : ""};
    }
    
    ${props => props.$hasIcon && `
        padding-right: 22px;
        position: relative;
        ${StyledIconButton} {
            position: absolute;
            right: 2px;
            top: 2px;   
        }
    `}
`;

